import { InAppState } from "../base/InAppState";
import template from "./PlaceDetailTemplate.html";

import { getPlace } from "../../data/content";

/**
 * PlaceDetailState — a single recommendation (`/place/:id`). Full-bleed
 * sub-page opened from the home rail; back returns to the home tab.
 */
export class PlaceDetailState extends InAppState
{
    static ROUTE = "/place/:id";
    static ID = "place-detail";

    showsBottomNav() { return false; }

    async enter()
    {
        const place = getPlace( this.routeParams.getParam( "id" ) );
        if ( !place )
        {
            this.app.router.redirect( "/" );
            return;
        }

        this.renderScreen( template, { p: place } );
        this.bind();
    }

    bind()
    {
        const root = this.app.view.pageContent;
        this.addEventListener( root.querySelector( '[data-id="back"]' ),  "click", () => this.app.router.redirect( "/" ) );
        this.addEventListener( root.querySelector( '[data-id="fav"]' ),   "click", ( e ) =>
        {
            e.currentTarget.classList.toggle( "detail__round--on" );
            this.app.view.toast( "Zu deinen Favoriten gespeichert.", "success" );
        } );
        this.addEventListener( root.querySelector( '[data-id="route"]' ), "click", () => this.app.view.toast( "Route wird gestartet …", "info" ) );
    }
}
